import { useState } from "react";
import { convertDayPartSelectionToScheduleOptionInputs } from "../converters/converter"; // adjust path
import { PlaydateInvite, InviteStatus, useUpdatePlaydateInviteMutation } from "../../../gql/types"; // adjust path
import { DayPartSelection } from "../../../components/time/types"; // adjust path
import { useToastContext } from "contexts/ToastContext";

type SubmitFinalizeOptions = {
    invite: PlaydateInvite;
    selection: DayPartSelection | null;
    onCompletion: (success: boolean, updatedInvite?: PlaydateInvite) => void;
    onFinalizeSelectionOverride?: (selection: DayPartSelection) => Promise<PlaydateInvite>;
};

export function useSubmitFinalizeInvite() {
    const [loading, setLoading] = useState(false);
    const [updateInvite] = useUpdatePlaydateInviteMutation();
    const { pushToastEvent } = useToastContext();

    const submitFinalize = async ({
        invite,
        selection,
        onCompletion,
        onFinalizeSelectionOverride,
    }: SubmitFinalizeOptions) => {
        if (!selection) {
            onCompletion(false);
            return;
        }

        setLoading(true);
        try {
            let updatedInvite: PlaydateInvite;

            if (onFinalizeSelectionOverride) {
                updatedInvite = await onFinalizeSelectionOverride(selection);
            } else {
                const finalScheduleOption = convertDayPartSelectionToScheduleOptionInputs([selection]);
                const { data } = await updateInvite({
                    variables: {
                        inviteID: invite.inviteID,
                        input: {
                            finalScheduleOption,
                            status: InviteStatus.Confirmed,
                        },
                    },
                });
                if (!data?.updatePlaydateInvite) {
                    throw new Error("No updated invite returned");
                }
                updatedInvite = data.updatePlaydateInvite;
            }

            pushToastEvent({
                eventType: "success",
                message: "Finalized the date and time!",
            });

            onCompletion(true, updatedInvite);
        } catch (err) {
            console.error(err);
            pushToastEvent({
                eventType: "error",
                message: "Failed to finalize. Try again.",
            });
            onCompletion(false);
        } finally {
            setLoading(false);
        }
    };

    return { submitFinalize, loading };
}
